export default {
  type: 'hbar2',
  name: '横向柱状图',
  option: (data) => ({
    tooltip: false,
    legend: false,
    grid: {
      top: '5%',
      left: '3%',
      right: '4%',
      bottom: '3%',
    },
    xAxis: {
      show: false,
      type: 'value',
    },
    yAxis: {
      axisTick: false,
      type: 'category',
      inverse: true,
      data: data.x,
    },
    series: data.y.map((item) => ({
      type: 'bar',
      label: {
        show: true,
        position: 'right',
      },
      ...item,
    })),
  }),
};
